module.exports = __webpack_public_path__ + "static/media/union-pay-payment-wv.140ffe26.svg";